import { render, staticRenderFns } from "./FormResponseType8.vue?vue&type=template&id=e23c5fd0&scoped=true"
import script from "./FormResponseType8.vue?vue&type=script&lang=js"
export * from "./FormResponseType8.vue?vue&type=script&lang=js"
import style0 from "./FormResponseType8.vue?vue&type=style&index=0&id=e23c5fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23c5fd0",
  null
  
)

export default component.exports